import { render, staticRenderFns } from "./MtsTakipHazirlaniyor.vue?vue&type=template&id=71547a6c&scoped=true"
import script from "./MtsTakipHazirlaniyor.vue?vue&type=script&lang=ts"
export * from "./MtsTakipHazirlaniyor.vue?vue&type=script&lang=ts"
import style0 from "./MtsTakipHazirlaniyor.vue?vue&type=style&index=0&id=71547a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71547a6c",
  null
  
)

export default component.exports